// Lot 560 — carte « Ajoute un e-mail de secours » : membres connectés par WhatsApp SANS e-mail ; lot 604 — aussi
// « Ajoute un numéro WhatsApp de secours » : membres e-mail SANS numéro (un seul canal = compte perdu si ce canal l'est).
// « Plus tard » = tampon serveur users.backup_email_nudge_later_at → la carte revient 7 jours plus tard (tous appareils) ;
// disparaît définitivement dès que le compte a ses deux canaux.
export const BACKUP_EMAIL_NUDGE_DAYS = 7;

export const shouldNudgeBackupEmail = (user, now = Date.now()) => {
  if (!user || user.is_bot || user.is_church) return false;
  const hasPhone = !!(user.phone || "").trim();
  const hasEmail = !!(user.email || "").trim();
  if (hasPhone === hasEmail) return false; // les deux canaux (ou aucun, compte en cours de création) → rien
  const later = Date.parse(user.backup_email_nudge_later_at || "");
  return !Number.isFinite(later) || now - later >= BACKUP_EMAIL_NUDGE_DAYS * 86400000;
};
